import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import "angular-cookies";
import auth from "../../services/auth.js";
import env from "../../services/env.js";
import security from "../../services/security.js";
import companies from "../../services/companies.js";

class JobsdashboardController {
  constructor(
    $http,
    $localStorage,
    $state,
    $q,
    $window,
    $stateParams,
    $location,
    CommonService,
    AuthService,
    EnvService,
    CompaniesService,
    JobsService,
    EventsService,
    $timeout,
    SecurityService,
    $rootScope,
    $scope,
    TrackingService,
    ngProgressFactory,
    $cookies,
    $social,
    validation,
    branchio
  ) {
    this.name = "jobsdashboard";
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$auth = AuthService;
    this.$common = CommonService;
    this.currentUser = this.$auth.getUserData();
    this.$env = EnvService;
    this.$window = $window;
    this.$location = $location;
    this.$branchio = branchio;
    this.$stateParams = $stateParams;
    this.$events = EventsService;
    this.$timeout = $timeout;
    this.$jobs = JobsService;
    this.$security = SecurityService;
    this.$rootScope = $rootScope;
    this.fakeJobs = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25];
    this.tempWeeks = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    this.tempWeek = 1;
    this.$q = $q;
    this.$companies = CompaniesService;
    this.$social = $social;
    this.$tracking = TrackingService;
    this.displayVerificationSteps = false;
    this.alreadyInitialized = false;
    this.$scope = $scope;
    this.jobStatus = "Published";
    this.remain_loading_count = 0;
    this.companyVerificationData = {
      isVerified: true
    };
    this.pageNumber = 1;
    this.$progress = ngProgressFactory.createInstance();
    this.teamsPostedTo = [];
    this.weHaveOneCheckedJob = false;
    this.events_for_header = [];
    this.csvName = "Jobs " + moment().format() + ".csv";
    this.csvNameRoster = "Jobblers " + moment().format() + ".csv";
    this.setJobPostingLoadingStatus();
    this.uiViews = {
      is_company_verified: null,
      is_user_email_verified: null,
      is_search: null,
      is_loading: true,
      is_loading_jobs: false,
      no_jobs: null,
      company_has_logo: null,
      company_has_ein: null,
      completed: this.$auth.hasCompletedPaymentInformation(),
    };

    this.ui = {
      allChecked: false,
    };

    this.jobs = [];

    var _this = this;

    _this.SetEventToEventPagesListener = _this.$rootScope.$on("SetEventToEventPages", function ($event, params) {
      _this.jobs.forEach(function (job) {
        if (job.id === params.event.id) {
          job.cost = params.event.cost;
          if (params.action === "Add") {
            job.numberOfOpenings = params.event.numberOfOpenings + params.numberOfOpenings;
          } else {
            job.numberOfOpenings = params.event.numberOfOpenings - params.numberOfOpenings;
          }
          job.totalNumberOfJobbles = params.event.totalNumberOfJobbles;
        }
      });

      _this.getJobs();
    });

    _this.InitJobsDashboardLoaderListener = _this.$rootScope.$on("InitJobsDashboardLoader", function ($event, params) {
      _this.jobs.length = 0;
      _this.uiViews.is_loading = true;
    });

    _this.JobHasBeenScheduledListener = _this.$rootScope.$on("JobHasBeenScheduled", function ($event, params) {
      if (params.numberOfWeeksToScheduleJob > 0) {
        _this.displaySchedulingModal(params);
      }
    });

    _this.UnverifiedBankWarningListener = _this.$rootScope.$on("UnverifiedBankWarning", function ($event, banks) {
      _this.setUnverifiedWarning(banks);
    });

    _this.RecentUserUpdatedTrimmedListener = _this.$rootScope.$on("RecentUserUpdatedTrimmed", function ($event, data) {
      _this.currentUser = data;
      if (_this.currentUser) {
        _this.checkAdmin();
      }
      if (_this.$state.current === "jobsdashboard" && this.alreadyInitialized === false) {
        this.alreadyInitialized = true;
        _this.init();
      }
    });

    _this.$scope.$on("$destroy", _this.UserUpdateTriggerListener);
    _this.$scope.$on("$destroy", _this.UnverifiedBankWarningListener);
    _this.$scope.$on("$destroy", _this.JobHasBeenScheduledListener);
    _this.$scope.$on("$destroy", _this.InitJobsDashboardLoaderListener);
    _this.$scope.$on("$destroy", _this.SetEventToEventPagesListener);

    _this.initializeOnRefresh();
  }

  calculatePublishedJobs() {
    return this.currentUser.company.totalNumberOfPublishedEvents ? this.currentUser.company.totalNumberOfPublishedEvents : 0;
  }

  $onInit() {
    this.pullLatestUserData();
  }

  initializeOnRefresh() {
    if (this.alreadyInitialized === false) {
      this.alreadyInitialized = true;
      this.init();
    } else {
      if (this.$location.$$search) {
        if (this.$location.$$search.action) {
          if (this.$location.$$search.action === "login") {
          } else {
            //this.init();
          }
          //this.init();
        }
      }
    }
  }

  determineQueryParametersInUrl(queryParameter) {
    let result = {};

    if (!queryParameter) {
      if (Object.keys(this.$location.$$search).length > 0) {
        this.$state.transitionTo(
          "jobsdashboard",
          {
            filter: this.$location.$$search.filter,
            dashboardType: this.$location.$$search.dashboardType,
          },
          {notify: false}
        );

        if (this.$location.$$search.filter === "published") {
          this.tab(1);
        } else if (this.$location.$$search.filter === "draft") {
          this.tab(2);
        } else if (this.$location.$$search.filter === "completed") {
          this.tab(3);
        } else if (this.$location.$$search.filter === "archived") {
          this.tab(4);
        }

        return this.$location.$$search.filter;
      } else {
        this.$state.transitionTo("jobsdashboard",
          {
            filter: "published",
            dashboardType: this.$location.$$search.dashboardType,
          },
          {notify: false}
        );
        this.tab(0);
        return "published";
      }
    } else {

      if (queryParameter != "search") {
        this.$state.transitionTo(
          "jobsdashboard",
          {
            filter: queryParameter,
            dashboardType: this.$location.$$search.dashboardType,
          },
          {notify: false}
        );

        if (queryParameter === "published") {
          this.tab(1);
        } else if (queryParameter === "draft") {
          this.tab(2);
        } else if (queryParameter === "completed") {
          this.tab(3);
        } else if (queryParameter === "archived") {
          this.tab(4);
        }

        return queryParameter;

      }

      return queryParameter;

    }
  }

  /*
    TODO:
        we need to set the active list item based on what the url is, not the other way around
     */
  tab(index) {
    if (this.uiViews.is_loading_jobs === true && this.jobs.length !== 0) {
      return;
    }

    if (index === 0) {
      index = index + 1;
    }

    this.$timeout(() => {
      $(".tabbed-header-wrapper ul.tabbed-header li.active").removeClass("active");
      $(".tabbed-header-wrapper ul.tabbed-header li:nth-child(" + index + ")").addClass("active");
    }, 200);
  }

  figureOutParams(info) {
    let data = this.determineQueryParametersInUrl(info);

    if (data === "archived") {
      this.requestParams.cancelledStatus = true;
      this.requestParams.completedStatus = false;
      this.requestParams.isDraftStatus = null;
      this.requestParams.sort = "lastUpdated";
      this.requestParams.order = "desc";
      this.jobStatus = "Archived";
      //this.requestParams.offset = 0;
      //this.requestParams.max = 10;
      this.requestParams.list = "archived";

      this.jobQuery = null;
      this.uiViews.is_search = false;
      this.requestParams.multiSearch = null;
    } else if (data === "draft") {
      this.requestParams.cancelledStatus = null;
      this.requestParams.completedStatus = null;
      this.requestParams.isDraftStatus = true;
      this.requestParams.sort = "startTime";
      this.requestParams.order = "asc";
      this.jobStatus = "Draft";
      //this.requestParams.offset = 0;
      //this.requestParams.max = 10;
      this.requestParams.list = "draft";

      this.jobQuery = null;
      this.uiViews.is_search = false;
      this.requestParams.multiSearch = null;
    } else if (data === "published") {

      this.requestParams.cancelledStatus = null;
      this.requestParams.completedStatus = null;
      this.requestParams.isDraftStatus = false;
      this.requestParams.sort = "startTime";
      this.requestParams.order = "asc";
      this.jobStatus = "Published";
      //this.requestParams.offset = 0;
      //this.requestParams.max = 10;
      this.requestParams.list = "published";

      this.jobQuery = null;
      this.uiViews.is_search = false;
      this.requestParams.multiSearch = null;
    } else if (data === "completed") {
      this.requestParams.cancelledStatus = false;
      this.requestParams.completedStatus = true;
      this.requestParams.isDraftStatus = null;
      this.requestParams.sort = "endTime";
      this.requestParams.order = "desc";
      this.jobStatus = "Completed";
      //this.requestParams.offset = 0;
      //this.requestParams.max = 10;
      this.requestParams.list = "completed";
      this.jobQuery = null;
      this.uiViews.is_search = false;
      this.requestParams.multiSearch = null;
    } else if (data === "openings") {
      if (this.requestParams.sort === "numberOfOpenings") {
        if (this.requestParams.order === "asc") {
          this.requestParams.order = "desc";
        } else {
          this.requestParams.order = "asc";
        }
      }
      this.requestParams.sort = "numberOfOpenings";
    } else if (data === "accepted-applications") {
      if (this.requestParams.sort === "acceptedApplications") {
        if (this.requestParams.order === "asc") {
          this.requestParams.order = "desc";
        } else {
          this.requestParams.order = "asc";
        }
      }
      this.requestParams.sort = "acceptedApplications";
    } else if (data === "pending-applications") {
      if (this.requestParams.sort === "pendingApplications") {
        if (this.requestParams.order === "asc") {
          this.requestParams.order = "desc";
        } else {
          this.requestParams.order = "asc";
        }
      }
      this.requestParams.sort = "pendingApplications";
    } else if (data === "rate") {
      if (this.requestParams.sort === "payPerHour") {
        if (this.requestParams.order === "asc") {
          this.requestParams.order = "desc";
        } else {
          this.requestParams.order = "asc";
        }
      }
      this.requestParams.sort = "payPerHour";
    } else if (data === "job-title") {
      if (this.requestParams.sort === "name") {
        if (this.requestParams.order === "asc") {
          this.requestParams.order = "desc";
        } else {
          this.requestParams.order = "asc";
        }
      }
      this.requestParams.sort = "name";
    } else if (data === "start-date") {
      if (this.requestParams.sort === "startTime") {
        if (this.requestParams.order === "asc") {
          this.requestParams.order = "desc";
        } else {
          this.requestParams.order = "asc";
        }
      }
      this.requestParams.sort = "startTime";
    } else if (data === "end-date") {
      if (this.requestParams.sort === "endTime") {
        if (this.requestParams.order === "asc") {
          this.requestParams.order = "desc";
        } else {
          this.requestParams.order = "asc";
        }
      }
      this.requestParams.sort = "endTime";
    } else if (data === "search") {

      this.requestParams.cancelledStatus = null;
      this.requestParams.completedStatus = null;
      this.requestParams.isDraftStatus = null;
      this.requestParams.multiSearch = this.jobQuery;
      this.requestParams.sort = "lastUpdated";
      this.requestParams.order = "desc";
      this.requestParams.list = "search";

      if (this.$location.$$search.filter === "published") {
        this.requestParams.cancelledStatus = null;
        this.requestParams.completedStatus = null;
        this.requestParams.isDraftStatus = null;
        this.requestParams.multiSearch = this.jobQuery;
        this.requestParams.sort = "lastUpdated";
        this.requestParams.order = "desc";
        this.requestParams.list = "search";
      } else if (this.$location.$$search.filter === "draft") {
        this.requestParams.cancelledStatus = null;
        this.requestParams.completedStatus = null;
        this.requestParams.isDraftStatus = true;
        this.requestParams.multiSearch = this.jobQuery;
        this.requestParams.sort = "lastUpdated";
        this.requestParams.order = "desc";
        this.requestParams.list = "search";
      } else if (this.$location.$$search.filter === "completed") {
        this.requestParams.cancelledStatus = null;
        this.requestParams.completedStatus = true;
        this.requestParams.isDraftStatus = null;
        this.requestParams.multiSearch = this.jobQuery;
        this.requestParams.sort = "lastUpdated";
        this.requestParams.order = "desc";
        this.requestParams.list = "search";
      } else if (this.$location.$$search.filter === "archived") {
        this.requestParams.cancelledStatus = true;
        this.requestParams.completedStatus = null;
        this.requestParams.isDraftStatus = null;
        this.requestParams.multiSearch = this.jobQuery;
        this.requestParams.sort = "lastUpdated";
        this.requestParams.order = "desc";
        this.requestParams.list = "search";
      }

    }

  }

  copyingEventId() {

  }

  getJobs(data, clearPagination, paginating, sortIndex) {
    var _this = this;
    var paging = paginating;
    if (_this.uiViews.is_loading_jobs === true) {
      return;
    }

    _this.uiViews.is_loading = true;
    _this.ui.allChecked = false;
    _this.weHaveOneCheckedJob = false;

    if (paging !== true) {
      _this.uiViews.is_loading_jobs = true;
      _this.jobs.length = 0;
      _this.jobs = [];
    }

    this.figureOutParams(data);
    this.setLoader();

    let payload = this.requestParams;

    if (clearPagination) {
      this.pageNumber = 1;
      this.requestParams.offset = 0;
    }

    _this.$companies.getJobs(payload).then(
      function (response) {
          _this.processJobs(response.data, paging, sortIndex);
          _this.$timeout(() => {
            _this.unSetLoader();
          }, 1000);
      },
      function (error) {
        _this.unSetLoader();
      }
    );

    /*
        let dbType = this.determineDashboardType();

        console.log("dbType");
        console.dir(dbType);

        if (dbType === "OD") {
            _this.$companies.getJobs(payload).then(
                function (response) {
                    console.log("get jobs response");
                    console.dir(response);
                    _this.processJobs(response.data.hits.hits, paging, sortIndex);
                    _this.unSetLoader();
                },
                function (error) {
                    console.log("whats the error");
                    console.dir(error);
                    _this.unSetLoader();
                }
            );
        } else {
            _this.$companies.getJobs(payload).then(
                function (response) {
                    _this.processJobs(response.data, paging, sortIndex);
                    _this.unSetLoader();
                },
                function (error) {
                    console.dir("whats the error");
                    console.dir(error);
                    _this.unSetLoader();
                }
            );
        }*/
  }

  setName(job) {
    if (job.name.length > 64) {
      job.nameShort = job.name.substring(0, 65) + "...";
    } else {
      job.nameShort = job.name;
    }
  }

  setJobbleType(job) {
    if (job.subEvents[0].deduppedJobbles[0]) {
      job.jobbleTypeId = job.subEvents[0].deduppedJobbles[0].jobbleType.id;
      job.jobbleTypeName = job.subEvents[0].deduppedJobbles[0].jobbleType.name;
    }
  }

  processJobs(jobs, paginating, sortIndex) {
    var _this = this;

    try {
      jobs.forEach(function (job) {
        //job = job._source;
        job.isChecked = false;
        _this.setJobbleType(job);
        _this.setName(job);
        _this.addExtraAttributesToEvent(job);
        _this.isLongTerm(job);
        _this.setMenuForJob(job);
        job.canExtend = _this.setExtensionPermissions(job);
        _this.jobs.push(job);
      });
    } catch (err) {
      console.log("what is the error");
      console.dir(err);
    } finally {
      if (!paginating) {
        _this.weHaveOneCheckedJob = false;
      }

      this.prepJobsForCSV(this.jobs);
      this.uiViews.is_loading = false;
      this.uiViews.is_loading_jobs = false;
      this.$localStorage.events = this.jobs;
      this.enableToolTips();
      this.fancyLoad(this.jobs.length);
      this.showActionMenu();
      if (sortIndex) {
        _this.setSortHighlights(sortIndex);
      }
    }
  }

  setExtensionPermissions(job) {
    let result;
    if (job.isLongTerm === true && moment(job.endTime).isAfter(moment()) && this.$location.$$search.filter === "published") {
      console.log("we have an extension....");
      result = true;
    } else {
      result = false;
    }
    return result;
  }

  getStartAndEndDate(job) {
    return "Start date";
  }

  showActionMenu() {
    this.$timeout(() => {
      $(".jobs-dashboard-container-header-actions .jobs-dashboard-actions-list-container").show();
      $(".jobs-dashboard-footer a").show();
    }, 1000);
  }

  hideJobs() {
    this.$timeout(() => {
      $(".jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table tbody tr").addClass("hide-jobs");
    });
  }

  fancyLoad() {
    this.$timeout(() => {
      $(".jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table tbody tr").each(function (index) {
        $(this)
          .delay(index * 10)
          .show(50);
      });
    }, 200);
  }

  enableToolTips() {
    this.$timeout(() => {
      $(".display-icon").tooltip({});
      //$(".status-icon").tooltip({});
      $(".fill-score").tooltip({});
    }, 200);
  }

  setSortHighlights(index) {
    var _this = this;

    _this.$timeout(function () {
      //$('table.jobs-dashboard-jobs-table tbody tr td:nth-child(' + index + ')').addClass('high-light-column');
    }, 300);
  }

  getEventDate(raw_date, tz, job) {
    var _this = this;

    var date = new Date(raw_date);
    let user_time_zone = moment.tz.guess();
    let now = moment.tz(user_time_zone);

    if (tz) {
      let nowThere = moment.tz(tz);
      let timeInSec = (parseInt(now.utcOffset(), 10) - parseInt(nowThere.utcOffset())) * 60;
      let startTimeAsMoment = moment(raw_date);
      let st = job.startTime;
      let tzid = tz;
      // h:mm a
      return moment(date).tz(tz).format("MMM DD, YYYY");
    }
  }

  addExtraAttributesToEvent(event) {
    event.status = "Live";

    let startTimeOfJob = null;
    let endTimeOfJob = null;
    let paymentPending = null;
    let startTimeCheck = null;
    let endTimeCheck = null;

    startTimeOfJob = moment(event.startTime).format();
    endTimeOfJob = moment(event.endTime).format();
    startTimeCheck = moment().diff(startTimeOfJob, "minutes") >= -10;
    endTimeCheck = moment().diff(endTimeOfJob, "minutes") <= 10;
    paymentPending = moment().diff(endTimeOfJob, "minutes") >= 10;

    event.isDisplayed = this.determineDisplayLogic(event, event.subEvents[0].deduppedJobbles[0].isDisplayed);

    this.setEventsToHeader(event);

    if (event.shiftFillScore >= 90) {
      event.fillScoreClass = "green";
    } else if (event.shiftFillScore <= 98 && event.shiftFillScore >= 50) {
      event.fillScoreClass = "orange";
    } else {
      event.fillScoreClass = "red";
    }

    if (!this.currentUser.company.isVerified) {
      event.companyIsNotVerified = true;
      event.status = "Company Under Review";
      event.statusNew = "Company Under Review";
      event.listColor = "event-listing-color-red";
      return;
    } else {
      event.companyIsNotVerified = false;
    }
    if (!event.subEvents[0].deduppedJobbles[0]) {
      return;
    }
    if (event.isCancelled) {
      event.status = "Archived";
      event.statusNew = "Archived";
      event.listColor = "event-listing-color-black";
      return;
    }
    if (event.isCompleted) {
      event.status = "Completed";
      event.statusNew = "Completed";
      event.listColor = "event-listing-color-black";
      return;
    }
    if (!event.subEvents[0].deduppedJobbles[0].isPublished) {
      if (!this.currentUser.company.isVerified) {
        event.status = "Pending Approval";
        event.listColor = "event-listing-color-red";
        event.notpublished = true;
        return;
      } else {
        if (event.autoPost === true) {
          event.status = "Scheduled";
          event.statusNew = "Scheduled";
        } else {
          event.status = "Draft";
          event.statusNew = "Draft";
        }
        event.listColor = "event-listing-color-blue";
        event.notpublished = true;
        if (event.isCancelled) {
          event.status = "Archived";
          event.listColor = "event-listing-color-black";
          return;
        }
        return;
      }
    } else if (!event.subEvents[0].deduppedJobbles[0].isPublished && event.numberOfApprovedApplications === 1) {
      if (event.hired_driver) {
        event.status = "Filled - " + event.hired_driver;
      } else {
        event.status = "Published - Filled";
        event.statusNew = "Published - Filled";
      }
      event.listColor = "event-listing-color-orange";
      if (paymentPending === true) {
        if (event.hired_driver) {
          //console.log("coming right herelol");
          event.status = "Payment Pending - " + event.hired_driver;
        } else {
          event.status = "Payment Pending";
          event.statusNew = "Published";
          //_this.check_hired_numbers(event);
        }
        event.listColor = "event-listing-color-red";
        return;
      }
      return;
    } else if (!event.subEvents[0].deduppedJobbles[0].isPublished && event.orderNumber && event.numberOfApprovedApplications === 0) {
      event.status = "Removed from board";
      event.listColor = "event-listing-color-red";
      return;
    }
    if (event.subEvents[0].deduppedJobbles[0].isPublished) {
      if (event.isCompleted || event.isClosed) {
        event.status = "Completed";
        event.listColor = "event-listing-color-black";
        return;
      }
      if (event.isCancelled) {
        event.status = "Archived";
        event.listColor = "event-listing-color-black";
        return;
      }
      if (startTimeCheck === true && endTimeCheck === true) {
        event.status = "Live";
        event.statusNew = "Live";
        event.listColor = "event-listing-color-green";
        return;
      }
      if (paymentPending === true) {
        if (event.isSourcingPost) {
          event.status = "Removed - 30 Days Expired";
        } else {
          event.status = "Payment Pending";
          event.statusNew = "Payment Pending";
        }
        event.listColor = "event-listing-color-red";
        return;
      } else {
        event.status = "Published";
        event.statusNew = "Published";
        event.listColor = "event-listing-color-orange";
      }
    }
  }

  setEventsToHeader(event) {
    var _this = this;

    this.events_for_header.push(event);

    if (_this.events_for_header.length === _this.jobs.length) {
      let events = _this.events_for_header;
      _this.$timeout(function () {
        _this.$rootScope.$emit("SetEventsToScroller", {events: events});
      });
    }
  }

  determineDisplayLogic(event, isDisplayed) {
    let startTimeMoment = moment(event.startTime);
    let endTimeMoment = moment(event.endTime);
    let dateCreatedMoment = moment(event.dateCreated);
    let now = moment();
    let differenceInDays = startTimeMoment.diff(now, "days");
    let differenceToEndTime = endTimeMoment.diff(now, "hours");
    let differenceToCreationTime = dateCreatedMoment.diff(now, "minutes");
    let result = {};

    if (isDisplayed === false) {
      if (differenceToCreationTime >= -10) {
        result.value = false;
        result.message = "Thank you for creating a new job! Please give our system a few minutes to propagate this job to the appropriate jobblers.";
      } else if (differenceInDays >= 21) {
        result.value = false;
        result.message =
          "This job is not displayed on the job board because the start time of the first shift is more than three weeks in the future.";
      } else if (differenceInDays < 21) {
        if (differenceToEndTime < 48 && differenceToEndTime > 0) {
          result.value = false;
          result.message = "This job has been removed from the board because the last shift is less than 48 hours away.";
        } else if (differenceToEndTime < 48 && differenceToEndTime <= 0) {
          result.value = false;
          result.message = "This job has been removed from the job board because it has ended.";
        } else {
          if (event.shiftFillScore > 100) {
            result.value = false;
            result.message =
              "This job is not displayed on the board because the applicant fill score is greater than 100. No more jobblers are needed.";
          } else {
            result.value = false;
            result.message = "This job has been removed from the job board.";
          }
        }
      } else {
        result.value = false;
        result.message = "This job has met the threshold of applicants.";
      }
    } else {
      result.value = true;
      result.message = "Job is displaying";
    }

    return result;
  }

  checkAll() {
    if (this.ui.allChecked === false) {
      this.ui.allChecked = true;
      this.checkOrUncheckAll(true);
    } else {
      this.ui.allChecked = false;
      this.checkOrUncheckAll(false);
    }

    this.checkForAtleastOneCheckedJob();
  }

  checkForAtleastOneCheckedJob() {
    var _this = this;

    _this.jobs.forEach(function (job) {
      if (job.isChecked !== true) {
        _this.weHaveOneCheckedJob = false;
      }
    });

    _this.jobs.forEach(function (job) {
      if (job.isChecked === true) {
        _this.weHaveOneCheckedJob = true;
      }
    });
  }

  checkOrUncheckAll(checked) {
    this.jobs.forEach(function (job) {
      job.isChecked = checked;
    });
  }

  toggleActionMenu(job, index) {
    var _this = this;

    let i = index + 1;

    _this.$timeout(function () {
      $("table.jobs-dashboard-jobs-table tbody tr:nth-child(" + i + ") td:last-child .action-menu").slideToggle({duration: 100});
    });

    _this.$timeout(function () {
      $("table.jobs-dashboard-jobs-table tbody tr:nth-child(" + i + ") td").addClass("row-focus");
    }, 150);

    _this.$timeout(function () {
      $("table.jobs-dashboard-jobs-table tbody tr:nth-child(" + i + ") td:last-child .action-menu").focus();
    }, 300);
  }

  sendToLivePage(job) {
    this.$state.go("eventreviewapplicants", {eventId: job.id});
  }

  sendToPaymentPage(job) {
    this.$state.go("eventreviewapplicants", {eventId: job.id});
  }

  sendToOverviewPage(job) {
    this.$state.go("eventeditdetails", {eventId: job.id});
  }

  closeActionMenu(job, index) {

    let i = index + 1;

    this.$timeout(() => {
      $("table.jobs-dashboard-jobs-table tbody tr:nth-child(" + i + ") td:last-child .action-menu").hide();
      $("table.jobs-dashboard-jobs-table tbody tr:nth-child(" + i + ") td").removeClass("row-focus");
    }, 300);

  }

  init() {
    var _this = this;

    if (_this.currentUser) {
      let admin = _this.checkAdmin();
      _this.setActionMenu(admin);
      _this.checkVerification();
      _this.checkForVerifiedBankAccount(_this.currentUser.company.undeletedPaymentInfos);
      _this.getLatestUserData();
      _this.requestParams = {
        sort: null,
        max: 25,
        offset: 0,
        companyId: this.currentUser.company.id,
        completedStatus: null,
        cancelledStatus: null,
        dates: null,
        order: "asc",
        list: null,
      };
      this.getJobs();
    } else {
      _this.$state.go("signin");
    }
  }

  viewVerificationModal() {
    var _this = this;

    _this.$timeout(function () {
      $("#verify-email-warning").modal();
    });
  }

  getSettingsCTA() {
    const completed = this.$auth.hasCompletedPaymentInformation();

    if (!completed.payment_added) {
      return "your payment information";
    } else if (!completed.ein_complete) {
      return "your company EIN";
    } else {
      return "your company address";
    }
  }

  goToSettings() {
    const completed = this.$auth.hasCompletedPaymentInformation();

    this.$timeout(() => {
      if (!completed.payment_added) {
        this.$location.path(`/account-profile/${this.currentUser.company.id}/payment-information`);
      } else {
        this.$location.path(`/account-profile`);
      }
    });
  }

  checkVerification() {
    if (this.currentUser.company.isVerified === false || this.currentUser.company.isVerified === null) {
      this.uiViews.is_company_verified = false;
    } else {
      this.uiViews.is_company_verified = true;
    }

    if (this.currentUser.isVerified === false || this.currentUser.isVerified === null) {
      this.uiViews.is_user_email_verified = false;
    } else {
      this.uiViews.is_user_email_verified = true;
    }
  }

  inboxLink(id) {
    var _this = this;

    if (_this.$rootScope.channelsHaveLoaded && !_this.$rootScope.channels) {
      alert("This account has no active messages. If you think there are active messages please refresh the page.");
    } else {
      _this.$timeout(function () {
        _this.$location.path("/messages/event/" + id);
      });
    }
  }

  setMenuForJob(job) {
    var _this = this;

    if (job.status === "Draft" || job.status === "Scheduled" || job.companyIsNotVerified === true) {
      job.menu = [
        {
          name: "Overview",
          link: "/event/" + job.id + "/overview",
          ngClick: null,
          iconClass: "fas fa-info-circle",
        },
        {
          name: "Edit",
          link: "/event/" + job.id + "/edit",
          ngClick: null,
          iconClass: "fas fa-edit",
        },
        {
          name: "Publish",
          link: "/post-a-shift/walkthrough?eid=" + job.id,
          ngClick: null,
          iconClass: "fas fa-upload",
        },
        {
          name: "Manage Roster",
          link: "/event/" + job.id + "/review",
          ngClick: null,
          iconClass: "fas fa-users",
        },
      ];
    } else if (
      job.status === "Published" ||
      job.status === "Payment Pending" ||
      job.status === "Live" ||
      job.status === "Completed" ||
      job.statusNew === "Archived"
    ) {
      if (job.status === "Completed") {
        if (job.firstInvoices.length > 0) {
          job.invoice = job.firstInvoices[0].payment;
        } else {
          job.invoice = "";
        }

        job.menu = [
          {
            name: "Job overview",
            link: "/event/" + job.id + "/overview",
            ngClick: null,
            iconClass: "fas fa-info-circle",
          },
          {
            name: "Recap",
            link: "/event/" + job.id + "/review",
            ngClick: null,
            iconClass: "fas fa-file-invoice",
          },
          {
            name: "Edit",
            link: "/event/" + job.id + "/edit",
            ngClick: null,
            iconClass: "fas fa-edit",
          },
          {
            name: "Manage Roster",
            link: "/event/" + job.id + "/review",
            ngClick: null,
            iconClass: "fas fa-users",
          },
          // {
          //  name: "Download Roster",
          //  link : "",
          //  ngClick : null,
          //  iconClass : "fas fa-download"
          // },
          // {
          //  name: "View Roster",
          //  link : "/event/" + job.id + "/roster",
          //  ngClick : null,
          //  iconClass : "fas fa-eye"
          // },

          {
            name: "Make Payments",
            link: "/event/" + job.id + "/review",
            ngClick: null,
            iconClass: "fas fa-hand-holding-usd",
          },
          {
            name: "Add/Remove Openings",
            link: "",
            ngClick: "vm.setEventOpenings(job)",
            iconClass: "fas fa-user-plus",
          },
          {
            name: "Clone",
            link: "/post-a-shift/walkthrough?cid=" + job.id,
            ngClick: null,
            iconClass: "far fa-clone",
          },
          {
            name: "Copy Share Link",
            link: "",
            ngClick: null,
            iconClass: "fas fa-copy",
          },
          {
            name: "Copy Event & Jobble ID",
            link: "",
            ngClick: null,
            iconClass: "fas fa-copy",
          },
          /*{
                        name: "Promote Job",
                        link: "",
                        ngClick: null,
                        iconClass: "fas fa-ad",
                    },*/
          {
            name: "Invoice",
            link: "/invoice/" + job.invoice + "?eventId=" + job.id,
            ngClick: null,
            iconClass: "fas fa-file-invoice",
          },
        ];
      } else {
        job.menu = [
          {
            name: "Overview",
            link: "/event/" + job.id + "/overview",
            ngClick: null,
            iconClass: "fas fa-info-circle",
          },
          {
            name: "Manage Roster",
            link: "/event/" + job.id + "/review",
            ngClick: null,
            iconClass: "fas fa-users",
          },
          // {
          //  name: "Download Roster",
          //  link : "",
          //  ngClick : null,
          //  iconClass : "fas fa-download"
          // },
          // {
          //  name: "View Roster",
          //  link : "/event/" + job.id + "/roster",
          //  ngClick : null,
          //  iconClass : "fas fa-eye"
          // },
          {
            name: "Edit",
            link: "/event/" + job.id + "/edit",
            ngClick: null,
            iconClass: "fas fa-edit",
          },
          {
            name: "Live",
            link: "/event/" + job.id + "/live",
            ngClick: null,
            iconClass: "fas fa-concierge-bell",
          },
          {
            name: "Make Payments",
            link: "/event/" + job.id + "/review",
            ngClick: null,
            iconClass: "fas fa-hand-holding-usd",
          },
          {
            name: "Add/Remove Openings",
            link: "",
            ngClick: "vm.setEventOpenings(job)",
            iconClass: "fas fa-user-plus",
          },
          {
            name: "Clone",
            link: "/post-a-shift/walkthrough?cid=" + job.id,
            ngClick: null,
            iconClass: "far fa-clone",
          },
          {
            name: "Copy Share Link",
            link: "",
            ngClick: null,
            iconClass: "fas fa-copy",
          },
          {
            name: "Copy Event & Jobble ID",
            link: "",
            ngClick: null,
            iconClass: "fas fa-copy",
          },
          {
            name: "Extend Job",
            link: "",
            ngClick: null,
            iconClass: "fas fa-plus"
          }
        ];
      }
    }
  }

  openCloseExtendModal(toggle) {
    if (toggle === true) {
      this.$timeout(() => {
        $("#job-extended").modal("toggle");
      });
    } else {
      this.$timeout(() => {
        $("#job-extended").modal();
      });
    }
  }

  extendJob(job) {
    let extendPayload = {};
    extendPayload.jobbleIdExtend = job.subEvents[0].deduppedJobbles[0].id;
    extendPayload.totalWeeks = job.totalWeeks;
    this.extendPayload = extendPayload;
    this.openCloseExtendModal();
  }

  openExtendConfirmationModal() {
    this.$timeout(() => {
      $("#job-extended-confirm").modal();
    });
  }

  extendJobConfirm() {
    //only extend jobs that are currently live
    //end time is > now
    this.setLoader();

    let weeks = parseInt(this.tempWeek);
    this.extendPayload.weeks = (this.extendPayload.totalWeeks + weeks) - 1;

    this.$events.extendJob(this.extendPayload).then(
      (r) => {
        this.openCloseExtendModal(true);
        this.$timeout(() => {
          this.unSetLoader();
          this.tempWeek = 1;
          this.openExtendConfirmationModal();
        }, 1000);
      },
      (error) => {
        this.unSetLoader();
        this.tempWeek = 1;
        this.$timeout(() => {
          this.openCloseExtendModal(true);
        }, 1000);
      }
    );

  }

  setActionMenu(admin) {
    let menu = null;

    if (admin) {
      menu = [
        {
          name: "Overview",
          link: "/event/{{event.id}}/overview",
        },
        {
          name: "Review & Hire Applicants",
          link: "http://",
        },
        {
          name: "Message",
          link: "http://",
        },
        {
          name: "Roster",
          link: "http://",
        },
        {
          name: "Edit Details",
          link: "http://",
        },
        {
          name: "Live",
          link: "http://",
        },
        {
          name: "Make Payments",
          link: "http://",
        },
        {
          name: "Add/Remove Openings",
          link: "http://",
        },
        {
          name: "Clone",
          link: "http://",
        },
        {
          name: "Copy Job Link",
          link: "http://",
        },
        {
          name: "Copy Event ID",
          link: "http://",
        },
        {
          name: "Unpublish",
          link: "http://",
        },
        {
          name: "Delete",
          link: "http://",
        },
      ];
    } else {
      menu = [];
    }

    this.actionMenu = menu;
  }

  checkAdmin() {
    let res = null;

    if (this.currentUser.username.indexOf("jobble.com") !== -1 || this.currentUser.username.indexOf("jobbleapp.com") !== -1) {
      this.currentUser.isAdmin = true;
      res = true;
    } else {
      this.currentUser.isAdmin = false;
      res = false;
    }

    return res;
  }

  setEventOpenings(event) {
    var _this = this;

    _this.$timeout(function () {
      _this.$rootScope.$emit("SetEventToEventDialog", {event: event});
    });
  }

  closeJob(job) {
    this.$timeout(() => {
      $(
        ".jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table tbody.real-jobs tr.real-jobs-row-anchor-" +
        job.index +
        "  td .nested-event-pool-data"
      ).slideUp(250);
      job.index = null;
      job.isShowingAllWeeks = false;
    });
  }

  findAndDisappearShowingModals() {
    let jobThatsShowing = this.jobs.find((obj) => {
      return obj.isShowingAllWeeks === true;
    });

    return jobThatsShowing;
  }

  getPoolData(d) {
    this.$companies.getEventPoolData(d).then(
      (response) => {
        if (response) {
        }
      },
      (error) => {
      }
    );
  }

  showEventPoolData(job, i) {

    let payload = {
      eventPoolId: job.eventPoolId,
      offset: 0,
      direction: "asc",
      max: 25,
      sort: "startTime",
    };

    this.getPoolData(payload);

    let showingJob = this.findAndDisappearShowingModals();

    if (showingJob) {
      this.closeJob(showingJob);
      if (job.id === showingJob.id) {
        return;
      }
    }

    job.isShowingAllWeeks = true;
    job.index = i;

    this.$timeout(() => {
      $(
        ".jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table tbody.real-jobs tr.real-jobs-row-anchor-" +
        i +
        "  td .nested-event-pool-data"
      ).slideDown(250);
    });
  }

  copyJobbleID(event) {

    let company = "Test Company Name";
    let title = event.name;
    let jobbleId = event.subEvents[0].deduppedJobbles[0].id;
    let url = "";

    this.$branchio.createLinks(jobbleId, title, company, url).then((links) => {
      this.$timeout(() => {
        let text_to_share = links.email;
        //var text_to_share = origin + "/job/" + event.subEvents[0].deduppedJobbles[0].id;
        // create temp element
        var copyElement = document.createElement("span");
        copyElement.appendChild(document.createTextNode(text_to_share));
        copyElement.id = "tempCopyToClipboard";
        angular.element(document.body.append(copyElement));
        // select the text
        var range = document.createRange();
        range.selectNode(copyElement);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
        // copy & cleanup
        document.execCommand("copy");
        window.getSelection().removeAllRanges();
        copyElement.remove();
      });
    });

  }

  copyEventID(event) {

    let eventId = event.id;
    let jobbleId = event.subEvents[0].deduppedJobbles[0].id;

    var text_to_share = "Event ID: " + eventId + ", Jobble ID: " + jobbleId;
    // create temp element
    var copyElement = document.createElement("span");
    copyElement.appendChild(document.createTextNode(text_to_share));
    copyElement.id = "tempCopyToClipboard";
    angular.element(document.body.append(copyElement));
    // select the text
    var range = document.createRange();
    range.selectNode(copyElement);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(range);
    // copy & cleanup
    document.execCommand("copy");
    window.getSelection().removeAllRanges();
    copyElement.remove();
  }

  checkJob(job) {
    if (job.isChecked === true) {
      job.isChecked = false;
    } else {
      job.isChecked = true;
    }

    this.checkForAtleastOneCheckedJob();
  }

  sortTable(value, index) {
    var _this = this;

    if (_this.uiViews.is_company_verified === false) {
      alert("Please wait for your company to be verified");
      return;
    }

    _this.ui.allChecked = false;

    if (value === "location" || value === "status") {
      return;
    }

    _this.getJobs(value, null, null, index);
  }

  updateJobStatus(job, status) {
    var _this = this;
  }

  updateJobsList(data, list, status, hasError) {
    var _this = this;

    let errors = [];
    let success = [];

    if (status === "unpublished") {
      if (hasError === true) {
        data.events.forEach(function (event) {
          if (event.status !== "OK") {
            let error = {};
            error.message = event.message;
            error.eventId = event.id;
            errors.push(error);
          } else {
            success.push(event);
          }
        });
        _this.updateNumbersOfOtherLists(success, status);
      } else {
        _this.jobs.forEach(function (job, i) {
          list.forEach(function (item, x) {
            if (item.id === job.id) {
              job.statusNew = "Draft";
            }
          });
        });
        _this.updateNumbersOfOtherLists(list, status);
      }
    } else if (status === "published") {
      if (hasError === true) {
        data.events.forEach(function (event) {
          if (event.status !== "OK") {
            let error = {};
            error.message = event.message;
            error.eventId = event.id;
            errors.push(error);
          } else {
            success.push(event);
          }
        });

        try {
          if (errors.length > 0) {
            errors.forEach(function (error) {
              //console.log("each error");
              //alert("Event ID " + error.eventId + " was not published.\nERROR: " + error.message);
            });
          }
        } catch (err) {
          console.log("error loopings errors array");
        } finally {
          if (success.length > 0) {
            _this.updateNumbersOfOtherLists(success, status);
          }
        }
      } else {
        _this.jobs.forEach(function (job) {
          list.forEach(function (item) {
            if (item.id === job.id) {
              job.statusNew = "Published";
            }
          });
        });
        _this.updateNumbersOfOtherLists(list, status);
      }
    } else if (status === "archived") {
      if (hasError === "true") {
        _this.jobs.forEach(function (job) {
          list.forEach(function (item) {
            if (item.id === job.id) {
              job.statusNew = "Archived";
              job.status = "Archived";
            }
          });
        });
        _this.updateNumbersOfOtherLists(list, status);
      } else {
        _this.updateNumbersOfOtherLists(list, status);
      }
    } else if (status === "restored") {
      if (hasError === true) {
        data.events.forEach(function (event) {
          if (event.status !== "OK") {
            let error = {};
            error.message = event.message;
            error.eventId = event.id;
            errors.push(error);
          } else {
            success.push(event);
          }
        });

        try {
          if (errors.length > 0) {
            errors.forEach(function (error) {
              console.log("each error");
              alert("Event ID " + error.eventId + " was not published.\nERROR: " + error.message);
            });
          }
        } catch (err) {
          console.log("error loopings errors array");
        } finally {
          if (success.length > 0) {
            _this.updateNumbersOfOtherLists(success, status);
          }
        }
      } else {
        _this.updateNumbersOfOtherLists(list, status);
      }
    } else if (status === "complete") {
      if (hasError === "true") {
        _this.jobs.forEach(function (job) {
          list.forEach(function (item) {
            if (item.id === job.id) {
              job.statusNew = "Complete";
              job.status = "Complete";
            }
          });
        });
        _this.updateNumbersOfOtherLists(list, status);
      } else {
        _this.updateNumbersOfOtherLists(list, status);
      }
    }

    this.getJobs();

    if (errors.length > 1) {
      _this.alertErrors(errors, data.events, success);
    } else {
      _this.findCheckedToUnCheck();
    }
  }

  alertErrors(errors, all, success) {
    var _this = this;

    alert(
      "Looks like " +
      errors.length +
      " out of the " +
      all.length +
      " jobs had an error with this process. Please make sure the pay rate is high enough. The other jobs were published"
    );

    _this.uncheckJobsWithError(errors);
  }

  uncheckJobsWithError(errors) {
    var _this = this;

    try {
      errors.forEach(function (error) {
        _this.jobs.forEach(function (job) {
          if (error.eventId === job.id) {
            job.isChecked = false;
          }
        });
      });
    } finally {
      _this.findCheckedToUnCheck();
    }
  }

  processJobsThatAreBeingClosed(jobs) {
    var _this = this;

    let listOfBadJobs = [];

    try {
      jobs.forEach(function (oneJob) {
        let endTimeMoment = moment(oneJob.job.endTime);

        if (currentTime.isBefore(endTimeMoment)) {
          listOfBadJobs.push(oneJob.job);
        }
      });
    } catch (err) {

    } finally {
      return listOfBadJobs;
    }
  }

  handleCompletionError(jobs) {
    let jobIds = "";

    try {
      jobs.forEach(function (job) {
        jobIds = jobIds + job.id + ", ";
      });
    } finally {
      let jobIdsSubStr = jobIds.substring(0, jobIds.length - 2);

      alert(
        "You are attempting to complete " +
        jobs.length +
        " jobs that are " +
        "still currently live. Please remove them from the list before proceeding " +
        "with the completion process. \nThe job identification numbers to remove are: \n" +
        jobIdsSubStr
      );
    }
  }

  completeJobs() {
    var _this = this;

    if (_this.weHaveOneCheckedJob === false) {
      return false;
    }

    let list = _this.findChecked();
    let listOfFullJobs = _this.findCheckedFullJob();
    let listOfBadJobs = _this.processJobsThatAreBeingClosed(listOfFullJobs);

    if (listOfBadJobs.length > 0) {
      _this.handleCompletionError(listOfBadJobs);
      return;
    }

    _this.setLoader();

    _this.$events.bulkCloseEvent(list).then(
      function (response) {
        if (response.status === 200) {
          _this.updateJobsList(response.data, list, "complete", false);
        } else {
          _this.updateJobsList(response.data, list, "complete", true);
        }

        _this.unSetLoader();
      },
      function (error) {
        _this.unSetLoader();
      }
    );
  }

  publishJobs() {
    var _this = this;

    if (_this.weHaveOneCheckedJob === false) {
      return false;
    }

    _this.setLoader();

    let list = _this.findChecked();

    _this.$events.bulkPublish(list).then(
      function (response) {
        if (response.data.message === "Events published without errors") {
          _this.updateJobsList(response.data, list, "published", false);
        } else if (response.data.message === "Events published with errors") {
          _this.updateJobsList(response.data, list, "published", true);
        }
        _this.unSetLoader();
      },
      function (error) {
        _this.unSetLoader();
      }
    );
  }

  unpublishJobs() {
    var _this = this;

    if (_this.weHaveOneCheckedJob === false) {
      return false;
    }

    let list = _this.findChecked();

    _this.setLoader();

    _this.$events.bulkUnpublish(list).then(
      function (response) {
        if (response.data.message === "Events unpublished without errors") {
          _this.updateJobsList(response.data, list, "unpublished", false);
        } else if (response.data.message === "Events unpublished with errors") {
          _this.updateJobsList(response.data, list, "unpublished", true);
        }

        _this.unSetLoader();
      },
      function (error) {
        _this.unSetLoader();
      }
    );
  }

  restoreJobs() {
    var _this = this;
    if (_this.weHaveOneCheckedJob === false) {
      return false;
    }
    let list = _this.findChecked();
    _this.setLoader();
    _this.$events.bulkRestore(list).then(
      function (response) {
        if (response.data.message === "Events restored without errors") {
          _this.updateJobsList(response.data, list, "restored", false);
        }

        _this.unSetLoader();
      },
      function (error) {
        _this.unSetLoader();
      }
    );
  }

  reopenJobs() {
    var _this = this;

    if (_this.weHaveOneCheckedJob === false) {
      return false;
    }

    let choice = confirm("Are you sure you want to complete this job?");

    if (choice === true) {
      let list = _this.findChecked();

      _this.setLoader();
      _this.$events.bulkReopen(list).then(
        function (response) {
          if (response.data[0].status === "OK") {
            _this.updateJobsList(response.data, list, "restored", false);
          }

          _this.unSetLoader();
        },
        function (error) {
          _this.unSetLoader();
        }
      );
    } else {
      return;
    }
  }

  archiveJobs() {
    var _this = this;

    if (_this.weHaveOneCheckedJob === false) {
      return false;
    }

    let choice = confirm(
      "Warning: Once the selected job(s) are " +
      "archived all applicants will be lost and the job will be cancelled.  " +
      "\nIf you would like to continue please press OK."
    );

    if (choice === true) {
      let list = _this.findChecked();

      _this.setLoader();

      _this.$events.bulkArchive(list).then(
        function (response) {
          if (response.data.message === "Events archived without errors") {
            _this.updateJobsList(response.data, list, "archived", false);
          }

          _this.unSetLoader();
        },
        function (error) {
          _this.unSetLoader();
        }
      );
    } else {
      return;
    }
  }

  updateNumbersOfOtherLists(list, type) {
    var _this = this;

    if (type === "unpublished") {
      _this.currentUser.company.totalNumberOfDraftEvents = _this.currentUser.company.totalNumberOfDraftEvents + list.length;
      if (_this.requestParams.list === "published") {
        _this.currentUser.company.totalNumberOfPublishedEvents = _this.currentUser.company.totalNumberOfPublishedEvents - list.length;
      }
    } else if (type === "published") {
      _this.currentUser.company.totalNumberOfPublishedEvents = _this.currentUser.company.totalNumberOfPublishedEvents + list.length;
      if (_this.requestParams.list === "draft") {
        _this.currentUser.company.totalNumberOfDraftEvents = _this.currentUser.company.totalNumberOfDraftEvents - list.length;
      }
    } else if (type === "restored") {
      //vm.currentUser.company.totalNumberOfEvents - vm.currentUser.company.totalNumberOfNonCloseEvents + vm.currentUser.company.totalNumberOfCloseEvents
      _this.currentUser.company.totalNumberOfPublishedEvents = _this.currentUser.company.totalNumberOfPublishedEvents + list.length;
      _this.currentUser.company.totalNumberOfEvents = _this.currentUser.company.totalNumberOfEvents - list.length;
      //if (_this.requestParams.list === "archived") {
      //_this.currentUser.company.totalNumberOfPublishedEvents = _this.currentUser.company.totalNumberOfPublishedEvents + list.length;
      //}
    } else if (type === "archived") {
      _this.currentUser.company.totalNumberOfEvents = _this.currentUser.company.totalNumberOfEvents + list.length;
      if (_this.requestParams.list === "published") {
        _this.currentUser.company.totalNumberOfPublishedEvents = _this.currentUser.company.totalNumberOfPublishedEvents - list.length;
      } else if (_this.requestParams.list === "draft") {
        _this.currentUser.company.totalNumberOfDraftEvents = _this.currentUser.company.totalNumberOfDraftEvents - list.length;
      } else if (_this.requestParams.list === "completed") {
        _this.currentUser.company.totalNumberOfCloseEvents = _this.currentUser.company.totalNumberOfCloseEvents - list.length;
      }
    } else if (type === "complete") {
      _this.currentUser.company.totalNumberOfCloseEvents = _this.currentUser.company.totalNumberOfCloseEvents + list.length;
      if (_this.requestParams.list === "published") {
        _this.currentUser.company.totalNumberOfPublishedEvents = _this.currentUser.company.totalNumberOfPublishedEvents - list.length;
      }
    }
  }

  setLoader() {
    var _this = this;

    _this.$timeout(function () {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    var _this = this;

    _this.$timeout(function () {
      $("html").removeClass("wait");
    });
  }

  findCheckedToUnCheck() {
    var _this = this;

    let list = [];

    try {
      _this.jobs.forEach(function (job, i) {
        if (job.isChecked === true) {
          list.push(i);
        }
      });
    } finally {
      for (var i = list.length - 1; i >= 0; i--) {
        _this.jobs.splice(list[i], 1);
      }

      _this.ui.allChecked = false;
    }
  }

  findCheckedFullJob() {
    var _this = this;

    let list = [];

    try {
      _this.jobs.forEach(function (job) {
        if (job.isChecked === true) {
          list.push({job: job});
        }
      });
    } finally {
      return list;
    }
  }

  findChecked() {
    var _this = this;

    let list = [];

    try {
      _this.jobs.forEach(function (job) {
        if (job.isChecked === true) {
          list.push({id: job.id});
        }
      });
    } finally {
      return list;
    }
  }

  clearSearch() {
    this.jobQuery = null;
    this.uiViews.is_search = false;
    this.requestParams.multiSearch = null;
    this.getJobs("published");
  }

  jobSearchSubmit() {
    var _this = this;

    _this.uiViews.is_search = true;
    _this.getJobs("search");
  }

  jobSearchChange() {
    var _this = this;
  }

  getHeader() {
    return ["Job Title", "Location", "Status", "Start Date", "End Date", "Rate", "Openings", "Fill Score", "Confirms"];
  }

  getHeaderRoster() {
    return ["Last Name", "First Name", "Number", "Email", "Post Title", "Job Type", "City", "State", "Zip", "Date Application Was Submitted"];
  }

  getPayRate(job) {
    job.payRate = (job.subEvents[0].deduppedJobbles[0].jobblerRate / 100).toFixed(2);

    return job.payRate;
  }

  prepJobsForCSV(jobs) {
    var _this = this;

    let csv = [];

    _this.csv = [];

    try {
      jobs.forEach(function (job, i) {
        let start = _this.getEventDate(job.startTime, job.contactInfo.timeZoneId, job);
        let end = _this.getEventDate(job.endTime, job.contactInfo.timeZoneId, job);
        let rate = _this.getPayRate(job);

        let csvObj = {
          job_title: job.name,
          location: job.contactInfo.city,
          status: job.statusNew,
          start_date: start,
          end_date: end,
          rate: job.payRate,
          openings: job.numberOfOpenings,
          fill_score: job.shiftFillScore,
          confirms: job.confirmedShifts,
        };

        csv.push(csvObj);
      });
    } catch (err) {
    } finally {
      _this.csv = csv;
    }
  }

  exit(x) {
    if (x === 2) {
      this.$timeout(() => {
        $("#verify-email-warning").modal("hide");
      });
    } else if (x === 1) {
      this.$timeout(() => {
        $("#confirm-roster-download").modal("hide");
      });
    } else if (x === 3) {
      this.$timeout(() => {
        $("#promote-job").modal("hide");
      });
    } else if (x === 4) {
      this.$timeout(() => {
        $("#job-overview-modal").modal("hide");
        //$("#job-overview-modal").animate({width: 'toggle'}, 150);
      });
    } else if (x === 5) {
      this.$timeout(() => {
        $("#job-scheduled").modal("hide");
        $(".modal-backdrop.fade.in").removeClass();
      });
    } else if (x === 6) {
      this.$timeout(() => {
        $("#job-extended").modal("toggle");
      });
    } else if (x === 7) {
      this.$timeout(() => {
        $("#job-extended-confirm").modal("toggle");
      });
    }
  }

  loadRoster(job) {
    var _this = this;

    let csv = [];

    let roster = [];

    _this.setLoader();
    _this.csvRoster = null;
    _this.rosterDownloadIsDisable = true;

    _this.$timeout(function () {
      $("#confirm-roster-download").modal();
    }, 300);
    _this.$timeout(function () {
      $("#confirm-roster-download").modal();
    }, 300);

    _this.$events.getAcceptedApplicationsTrimmedRoster(job.subEvents[0].deduppedJobbles[0].subEventId, 100, 0).then(
      function (acceptedApplications) {
        var applications = acceptedApplications.data;

        try {
          try {
            applications.forEach(function (application, i) {
              let csvObj = {
                last_name: application.applicant.lastName,
                first_name: application.applicant.firstName,
                number: application.applicant.homeContactInfo.phoneMobile,
                email: application.applicant.email,
                post_title: job.name,
                job_type: "--",
                city: job.contactInfo.city,
                state: job.contactInfo.state,
                zip: job.contactInfo.zipCode,
                apply_date: job.dateCreated,
              };
              csv.push(csvObj);

              application.smallPic = application.applicant.filePROFILE_IMAGE1IMG_75x75;
              application.mediumPic = application.applicant.filePROFILE_IMAGE1IMG_75x75;
            });
          } catch (err) {
          } finally {
            csv.sort(function (a, b) {
              if (a.last_name < b.last_name) return -1;
              if (a.last_name > b.last_name) return 1;
              return 0;
            });
          }
        } finally {
          _this.unSetLoader();
          _this.csvRoster = csv;
          _this.rosterDownloadIsDisable = false;
        }
      },
      function (error) {
        _this.unSetLoader();
      }
    );
  }

  downloadRosterCSV() {
    var _this = this;

    if (_this.rosterDownloadIsDisable === true) {
      alert("Please let the roster download before clicking.");
      return;
    }

    _this.setLoader();

    _this.$timeout(function () {
      _this.exit(1);
    }, 200);

    _this.$timeout(function () {
      _this.unSetLoader();
    }, 500);
  }

  fixPhone(application) {

    if (application.applicant.homeContactInfo) {
      if (application.applicant.homeContactInfo.phoneMobile) {
        let num = application.applicant.homeContactInfo.phoneMobile;
        if (num.charAt(0) === "1") {
          num = num.slice(1, num.length);
        }
        let cleaned = ("" + num).replace(/\D/g, "");
        var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
          application.applicant.homeContactInfo.phoneMobile = "(" + match[1] + ") " + match[2] + "-" + match[3];
        } else {
          application.applicant.homeContactInfo.phoneMobile = num;
        }
      } else {
        application.applicant.homeContactInfo = {};
        application.applicant.homeContactInfo.phoneMobile = "--";
      }
    }
  }

  paginateJobs() {
    this.pageNumber = this.pageNumber + 1;

    if (this.checkForMoreJobs() === true) {
      return;
    }

    this.requestParams.offset = this.jobs.length;

    this.getJobs(this.requestParams.list, null, true);
  }

  checkForMoreJobs() {
    var _this = this;

    let result = null;

    if (_this.requestParams.list === "published") {
      if (_this.jobs.length < _this.currentUser.company.totalNumberOfPublishedEvents) {
        result = false;
      } else {
        result = true;
      }
    } else if (_this.requestParams.list === "archived") {
      if (
        _this.jobs.length <
        _this.currentUser.company.totalNumberOfEvents -
        (_this.currentUser.company.totalNumberOfNonCloseEvents + _this.currentUser.company.totalNumberOfCloseEvents)
      ) {
        result = false;
      } else {
        result = true;
      }
    } else if (_this.requestParams.list === "draft") {
      if (_this.jobs.length < _this.currentUser.company.totalNumberOfDraftEvents) {
        result = false;
      } else {
        result = true;
      }
    } else if (_this.requestParams.list === "completed") {
      if (_this.jobs.length < _this.currentUser.company.totalNumberOfCloseEvents) {
        result = false;
      } else {
        result = true;
      }
    } else if (_this.requestParams.list === "search") {
      result = false;
    }

    return result;
  }

  checkVerificationStatus() {
    var _this = this;

    _this.setLoader();

    _this.$auth.reloadCurrentUser();

    _this.$timeout(function () {
      _this.currentUser = _this.$auth.getUserData();
      _this.unSetLoader();
      $("#verify-email-warning").modal("hide");
    }, 1500);

    _this.$timeout(function () {
      if (_this.currentUser.isVerified === false || _this.currentUser.isVerified === null) {
        alert("Your email is still not verified. Please contact support.");
      } else {
        _this.uiViews.is_user_email_verified = true;
      }
    }, 1700);
  }

  promoteJob(event) {
    var _this = this;

    _this.promote_job = event;
    _this.$timeout(function () {
      $("#promote-job").modal();
    });
  }

  closePromoteModal() {
    var _this = this;

    _this.$timeout(function () {
      $("#promote-job").modal("toggle");
    });
  }

  confirmPromote() {
    var _this = this;

    _this.setLoader();

    _this.$events.promote_event(_this.promote_job.jobblePoolId).then(
      function (response) {
        _this.unSetLoader();

        if (response.data.status === "OK") {
          _this.exit(3);
          _this.$timeout(function () {
            alert("Your job was successfully promoted.");
          }, 500);
        } else {
          _this.exit(3);
          _this.$timeout(function () {
            alert(response.data.message);
          }, 500);
        }
      },
      function (error) {
        _this.unSetLoader();
        _this.exit(3);
        _this.$timeout(function () {
          alert("There was an error promoting your job. Please contact customer support.");
        }, 500);
      }
    );
  }

  displayBulkActionItems(inOrOut) {
    if (inOrOut === true) {
      this.weHaveOneCheckedJob = inOrOut;
    } else {
      this.checkForAtleastOneCheckedJob();
    }
  }

  hidebulkActionItems() {
    this.weHaveOneCheckedJob = false;
  }

  setUrl(index) {
    if (index === 1) {
    } else if (index === 2) {
    } else if (index === 3) {
    } else if (index === 4) {
    }
  }

  setOverviewModal(job) {

    this.getJob(job);
    this.overviewJob = null;

    this.heightOfModal = this.$window.innerHeight - 73;

    this.$timeout(() => {
      $("#job-overview-modal").modal();
      //$("#job-overview-modal").animate({width: 'toggle'}, 300);
    }, 200);
  }

  getJob(job) {
    var _this = this;

    _this.setLoader();

    _this.$events.getEventByIdTrimmedv2(job.id).then(
      function (response) {
        _this.setShifts(response.data);
        _this.unSetLoader();
      },
      function (error) {
        _this.unSetLoader();
      }
    );
  }

  getRequirements(job) {
    var _this = this;

    _this.setLoader();

    _this.$events.getEventByIdTrimmed(job.id).then(
      function (response) {
        _this.setShifts(response.data);
        _this.unSetLoader();
      },
      function (error) {
        _this.unSetLoader();
      }
    );
  }

  setShifts(event) {
    var _this = this;

    _this.teamsPostedTo = [];

    if (event.subEvents[0].deduppedJobbles[0].circles) {
      if (Object.keys(event.subEvents[0].deduppedJobbles[0].circles).length !== 0) {
        try {
          if (event.subEvents[0].deduppedJobbles[0]) {
            if (event.subEvents[0].deduppedJobbles[0].forCircleOnly === true) {
              _this.isPrivate = true;
            }
          }
        } finally {
          if (event.subEvents[0].deduppedJobbles[0].circles.length > 0) {
            event.subEvents[0].deduppedJobbles[0].circles.forEach(function (team) {
              _this.teamsPostedTo.push(team);
            });
          }
        }
      }
    }

    var minutes = event.subEvents[0].deduppedJobbles[0].jobbleDuration * 60;
    var minRounder = minutes % 60;

    var hours = Math.floor(minutes / 60);
    event.subEvents[0].deduppedJobbles[0].hours = hours;
    event.subEvents[0].deduppedJobbles[0].minutes = minRounder;

    let shifts = event.subEvents[0].deduppedJobbles[0].shifts;

    let userTimeZoneName = moment.tz.guess();

    let jobSiteInDST;
    let browserUserDST = moment().tz(userTimeZoneName).isDST();

    try {
      for (var x = 0; x < shifts.length; x++) {

        let jobSiteTimeZoneName = shifts[x].contactInfo.place.timeZoneId;
        let start = new Date(moment(shifts[x].timeInterval.startTime).format(""));
        let end = new Date(moment(shifts[x].timeInterval.endTime).format());

        jobSiteInDST = moment(start).tz(jobSiteTimeZoneName).isDST();

        let startMoment = moment.tz(start, "UTC");
        let endMoment = moment.tz(end, "UTC");

        let timeZone = shifts[x].contactInfo.place.timeZoneId;

        let jobDST = moment().tz(timeZone).isDST();

        //console.dir(moment((startMoment).tz(timeZone).isDST()));

        shifts[x].startTimeFullFormat = startMoment.tz(timeZone).format();
        shifts[x].endTimeFullFormat = endMoment.tz(timeZone).format();

        shifts[x].startDateFormatted = startMoment.tz(timeZone).format("MMM DD, YYYY");
        shifts[x].startTimeFormatted = startMoment.tz(timeZone).format("h:mmA");
        shifts[x].endTimeFormatted = endMoment.tz(timeZone).format("h:mmA");
        shifts[x].TZ = startMoment.tz(timeZone).zoneAbbr();

      }
    } finally {
      this.sortShiftsByStartTime(event);
    }
  }

  sortShiftsByStartTime(event) {
    var _this = this;
    event.subEvents[0].deduppedJobbles[0].shifts.sort(function (a, b) {
      return new Date(a.timeInterval.startTime).getTime() - new Date(b.timeInterval.startTime).getTime();
    });
    _this.overviewJob = event;
    _this.getRequirements();
    _this.setQuestions(event, event.id);
    _this.setPayRate(event);
  }

  setPayRate(job) {
    let company = this.currentUser.company;
    let payRateObj = {};

    job.shifts = job.subEvents[0].deduppedJobbles[0].shifts;
    payRateObj.payPerHour = job.subEvents[0].deduppedJobbles[0].payPerHour;
    payRateObj.jobblerRate = job.subEvents[0].deduppedJobbles[0].jobblerRate;
    payRateObj.openings = job.numberOfOpenings + job.numberOfApprovedApplications;

    let rate = company.defaultPlan.jobblerFeePct;
    let pay = parseFloat(payRateObj.payPerHour);
    let epi = 0.00001;
    let p = 100 - rate * 100;
    let x = parseFloat(pay) * 100;
    let z = x / p;
    let cost = Math.round((z + epi) * 100) / 100;
    let hours = null;

    job.shifts.forEach((shift) => {
      if (!shift) return;

      const startDate = new Date(shift.timeInterval.startTime);
      const endDate = new Date(shift.timeInterval.endTime);

      hours += (endDate.getTime() - startDate.getTime()) / 1000 / 60 / 60;
    });

    payRateObj.platform_hourly_cost = cost;
    payRateObj.platform_rate = Math.round(100 * (rate + epi) * 100) / 100;
    payRateObj.platform_fee = Math.round((cost - pay) * 100) / 100;

    payRateObj.estimated_cost = Math.round((cost + epi) * 100 * hours * parseFloat(payRateObj.openings)) / 100;

    this.payRateObj = payRateObj;
  }

  setQuestions(event, eventId) {
    var _this = this;

    let order;

    _this.$jobs.getQuestions(eventId).then(
      function (response) {
        let questions = response.data.surveyQuestions;

        if (questions && questions.length > 0) {
          questions.sort(function (a, b) {
            let order = null;

            if (a.displayOrder) {
              order = a.displayOrder - b.displayOrder;
            } else {
              order = a.id - b.id;
            }
          });

          event.surveyQuestions = questions;
        } else {
          event.surveyQuestions = [];
        }
      },
      function (error) {
        event.surveyQuestions = [];
      }
    );
  }

  getRequirements() {
    var _this = this;

    let data = {};
    data.eventId = _this.overviewJob.id;

    _this.$jobs.getRequirements(data).then(
      function (response) {
        _this.handleRequirements(response.data);
      },
      function (error) {
      }
    );
  }

  handleRequirements(data) {
    var _this = this;

    let requirements = null;

    if (data.length > 0) {
      _this.showReqs = true;
      requirements = data.sort((a, b) => {
        return a.position - b.position;
      });

      _this.requirements = requirements;
      _this.reqsLoaded = true;
    }
  }

  getShiftLocation(shift) {
    if (shift) {
      if (this.$security.isUndefinedOrNull(shift.contactInfo)) {
        return "";
      }
      var location = shift.contactInfo.streetLine1;
      if (!this.$security.isUndefinedOrNull(shift.contactInfo.city)) {
        location += " " + shift.contactInfo.city;
      }
      if (!this.$security.isUndefinedOrNull(shift.contactInfo.state)) {
        location += ", " + shift.contactInfo.state;
      }

      if (!this.$security.isUndefinedOrNull(shift.contactInfo.zipCode)) {
        location += " " + shift.contactInfo.zipCode;
      }

      return location;
    }
  }

  getDurationWithHoursAndMinutes(totalMinutes) {
    var hours = Math.floor(totalMinutes / 60);
    var minutes = totalMinutes % 60;
    return hours + "h " + minutes + "min";
  }

  getHoursAndMintuesFromStartToEnd(startTime, endTime) {
    var startMomentTime = moment(startTime);
    var endMomentTime = moment(endTime);
    var durationMinutes = endMomentTime.diff(startMomentTime, "minutes");

    return this.getDurationWithHoursAndMinutes(durationMinutes);
  }

  displayTimeZone(tz) {
    if (tz === "Eastern Standard Time") {
      return "EST";
    }
    if (tz === "Central Standard Time") {
      return "CST";
    }
    if (tz === "Mountain Standard Time") {
      return "MST";
    }
    if (tz === "Pacific Standard Time") {
      return "PST";
    }
    if (tz === "Alaska Standard Time") {
      return "AST";
    }
    if (tz === "Hawaii Standard Time") {
      return "HST";
    }
  }

  goToRoster(id) {
    this.$timeout(() => {
      this.$location.path("event/" + id + "/review");
    }, 100);
  }

  goToManageRoster() {
    this.exit(4);

    this.$timeout(() => {
      this.$location.path("event/" + this.overviewJob.id + "/review");
    }, 300);
  }

  displaySchedulingModal(event) {

    let numberOfWeeks = parseFloat(event.numberOfWeeksToScheduleJob) + 1;

    this.schedulingMsg = "You have scheduled this job to run for " + numberOfWeeks + " weeks.";

    this.$timeout(() => {
      $("#job-scheduled").modal();
    }, 300);

  }

  setUnverifiedWarning(banks) {
    this.unverifiedBankId = banks[0].id;
    this.uiViews.company_has_unverified_bank = true;
  }

  checkForVerifiedBankAccount(info) {
    let unverifiedBanks = [];
    let verifiedBanks = [];
    let cards = [];

    try {
      if (info.length > 0) {
        info.forEach(function (x) {
          if (x.bankName && x.validated === null) {
            unverifiedBanks.push(x);
          } else if (x.bankName && x.validated === true) {
            verifiedBanks.push(x);
          } else if (x.cardBrand) {
            cards.push(x);
          }
        });
      }
    } catch (err) {
      console.log("we have an error finding bank accounts");
      console.dir(err);
    } finally {
      if (unverifiedBanks.length > 0) {
        this.$timeout(() => {
          this.$rootScope.$emit("UnverifiedBankWarning", unverifiedBanks);
        }, 2000);
      }
    }
  }

  isLongTerm(job) {
    let isLongTerm = job.isLongTerm;
    let admin = this.currentUser.isAdmin;
    if (isLongTerm === true) {
      if (job.weeks === null) {
        job.currentWeek = false;
      } else {
        job.currentWeek = job.totalWeeks - job.weeks;
      }
    }
  }

  getLatestUserData() {
    this.$timeout(() => {
      if (this.currentUser) {
        this.$auth.refreshCurrentUserDashboard().then((result) => {
          this.currentUser.company.totalNumberOfCloseEvents = result.company.totalNumberOfCloseEvents;
          this.currentUser.company.totalNumberOfDraftEvents = result.company.totalNumberOfDraftEvents;
          this.currentUser.company.totalNumberOfEvents = result.company.totalNumberOfEvents;
          this.currentUser.company.totalNumberOfNonCloseEvents = result.company.totalNumberOfNonCloseEvents;
          this.currentUser.company.totalNumberOfPublishedEvents = result.company.totalNumberOfPublishedEvents;
          if (!this.currentUser.company.companyLogoUri) {
            this.$rootScope.$emit("GetLogo", this.currentUser);
          }
          if (this.currentUser.isAdmin) {
            this.getApplicationErrors();
          }
        });
      }
    }, 300);
  }

  getApplicationErrors() {
    this.displayInAppNotification = false;
    this.$companies.getApplicationErrors().then(
      (response) => {
        if (response) {
          if (response.data) {
            if (response.data.length > 0) {
              this.displayInAppNotification = true;
              if (this.currentUser.isAdmin) {
                this.alerts = this.$companies.createInAppNotifications(response.data);
                this.showAlerts();
              }
            }
          }
        }
      },
      (error) => {
        console.log("application errors - error");
        console.dir(error);
      }
    );
  }

  closeNotification(index, alert) {
    let indexPlus = index + 1;
    this.$timeout(() => {
      $(".in-app-notification:nth-child(" + indexPlus + ")").removeClass("show-alerts");
      $(".in-app-notification:nth-child(" + indexPlus + ")").addClass("hide-alerts");
    });

    this.achknowledgeApplicationError(alert.rawAlert.id);
  }

  viewNotification(index, alert) {
    let indexPlus = index + 1;

    this.$timeout(() => {
      $(".in-app-notification:nth-child(" + indexPlus + ")").removeClass("show-alerts");
      $(".in-app-notification:nth-child(" + indexPlus + ")").addClass("hide-alerts");
    });

    this.achknowledgeApplicationError(alert.rawAlert.id);
    this.$state.go("eventreviewapplicants", {eventId: alert.eventId, userId: alert.rawAlert.applicantUser.id});
  }

  achknowledgeApplicationError(id) {
    this.$companies.achknowledgeApplicationError(id).then(
      (response) => {
        if (response) {
        }
      },
      (error) => {
        console.log("achknowledgeApplicationError - error");
        console.dir(error);
      }
    );
  }

  showAlerts() {
    this.$timeout(() => {
      $(".in-app-notification").addClass("show-alerts");
    }, 300);
  }

  setJobPostingLoadingStatus() {
    this.$timeout(() => {
      //this.$rootScope.postingLoadingStatus = 0;
    }, 300);
  }

  triggerCloningModal(job) {
    this.$progress.start();
    this.$rootScope.progress = this.$progress;
  }

  determineDashboardType() {
    return "OD";
  }

  pullLatestUserData(checkingForUserEmailVerification) {
    let companyVerificationData = {};
    if (this.currentUser) {
      let token = this.currentUser.access_token;
      if (this.currentUser.company.isVerified !== true) {
        this.setLoader();
        this.$auth.validateCompanyByTokenWeb(token).then((response) => {
          let user = response.data;
          companyVerificationData.logo = user.company.companyLogoUri;
          companyVerificationData.isUserVerified = user.isVerified;
          companyVerificationData.paymentInfo = user.company.undeletedPaymentInfos;
          if (
            companyVerificationData.logo &&
            companyVerificationData.isUserVerified &&
            companyVerificationData.paymentInfo.length > 0) {
              companyVerificationData.isVerified = true;
            }
            this.companyVerificationData = companyVerificationData;
            if (checkingForUserEmailVerification) {
              this.$timeout(() => {
                $("#verify-email-warning").modal("hide");
              });
              this.$timeout(()=> {
                if (!companyVerificationData.isUserVerifed) {
                  alert("We do not have your email as verified. Please give our system another minute and try again. " +
                    "If the problem persists please contact support at sales@jobble.com.");
                }
              }, 200);
            }
            this.displayVerificationSteps = true;
            this.unSetLoader();
          }, function(error) {
            this.unSetLoader();
            this.displayVerificationSteps = true;
          });
        }
      }
    }

}

JobsdashboardController.$inject = [
  "$http",
  "$localStorage",
  "$state",
  "$q",
  "$window",
  "$stateParams",
  "$location",
  "common",
  "auth",
  "env",
  "companies",
  "jobs",
  "events",
  "$timeout",
  "security",
  "$rootScope",
  "$scope",
  "tracking",
  "ngProgressFactory",
  "$cookies",
  "social",
  "validation",
  "branchio",
];

export default JobsdashboardController;



// WEBPACK FOOTER //
// ./client/app/components/jobsdashboard/jobsdashboard.controller.js